/**
 * Format a number or string as USD currency
 * @param value - The value to format (number, string, or undefined)
 * @returns Formatted currency string (e.g., "$10,000,000,000")
 */
export const formatCurrency = (value: number | string | undefined): string => {
  if (value === undefined || value === null || value === '') return 'N/A';
  
  const num = typeof value === 'string' ? parseFloat(value) : value;
  if (isNaN(num)) return 'N/A';
  
  return `$${num.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
};

/**
 * Format a number or string as USD currency without the dollar sign
 * @param value - The value to format (number, string, or undefined)
 * @returns Formatted number string (e.g., "10,000,000,000")
 */
export const formatNumber = (value: number | string | undefined): string => {
  if (value === undefined || value === null || value === '') return 'N/A';
  
  const num = typeof value === 'string' ? parseFloat(value) : value;
  if (isNaN(num)) return 'N/A';
  
  return num.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
};
